<template>
  <div class="row pt-3 px-md-5 mx-md-5 mx-1 mb-5 justify-content-center">
    <div class="col-12 text-center mt-3" v-if="mostrar_tiempo_restante">
        {{tiempo_restante_horas}} hrs.
      </div>
    <div class="col-12 mt-3 text-center">
      <h4>Catell</h4>
    </div>
    <div class="col-md-10 mt-5">
      <div v-bind:class="loading">
        <div class="d-flex justify-content-center">
          <div class="spinner-border m-5" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <div v-bind:class="result">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col" class="text-center">Pregunta</th>
              <th scope="col" class="text-center">Respuesta</th>
              <th scope="col" class="text-center"></th>
            </tr>
          </thead>
          <tbody v-for="pregunta of examen.preguntas" v-if="pregunta.active">
            <tr>
              <td rowspan="3">{{pregunta.numero}}</td>
              <td rowspan="3">{{pregunta.nompregunta}}</td>
              <td 
                v-on:click="Seleccionar_Respuesta(pregunta.numero, 1)" 
                class="select_respuesta">
                  Si
              </td>
              <td
                v-on:click="Seleccionar_Respuesta(pregunta.numero, 1)" 
                class="text-center select_respuesta">
                <i 
                  v-if="Number(pregunta.respuesta)==1" class="fas fa-check" />
              </td>
            </tr>
            <tr>
              <td 
                v-on:click="Seleccionar_Respuesta(pregunta.numero, 2)" 
                class="select_respuesta">
                  No
              </td>
              <td 
                v-on:click="Seleccionar_Respuesta(pregunta.numero, 2)" 
                class="text-center select_respuesta">
                <i 
                  v-if="Number(pregunta.respuesta)==2" class="fas fa-check" />
              </td>
            </tr>
            <tr>
              <td 
                v-on:click="Seleccionar_Respuesta(pregunta.numero, 3)" 
                class="select_respuesta">
                  Ninguna de las dos
              </td>
              <td 
                v-on:click="Seleccionar_Respuesta(pregunta.numero, 3)" 
                class="text-center select_respuesta">
                <i 
                  v-if="Number(pregunta.respuesta)==3" class="fas fa-check" />
              </td>
            </tr>
          </tbody>
        </table>
        <div class="row">
          <div class="col-12 text-center mt-3">
            <button class="btn btn-success mr-3" v-if="pregunta_actual>1" v-on:click="Anterior_Pregunta">
              <i class="fas fa-arrow-circle-left"></i>
              Anterior
            </button>
            <button class="btn btn-success" :disabled="puedo_continuar==0" v-on:click="Continuar_Siguiente_Pregunta">
              Siguiente   
              <i class="fas fa-arrow-circle-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 mt-5 text-center">
      <h5>Pregunta <b>{{pregunta_actual}}</b> / {{total_preguntas}}</h5>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading:'d-none',
      result:'',
      cantidad_siguiente:1,
      continuar_siguiente_pregunta_al_contestar:false,
      examen:{
        idexamen:null,
        abreviatura:"catell",
        nombre:"Catell",
        avance:70,
        preguntas:[]
      },
      pregunta_actual:1,
      avance:0,
      total_preguntas:0
    }
  },
  methods:{
    Buscar_Pregunta_Que_Se_Quedo(){
      var si_hay_contestadas=false;
      var i_contestada=null;
      var pregunta_activa=false;
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        this.examen.preguntas[i].active=false;
      }
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        if (this.examen.preguntas[i].respuesta!=null) {
          for (var x = 0; x < i; x++) {
            this.examen.preguntas[x].active=false;     
          }
          this.examen.preguntas[i].active=true;
          this.pregunta_actual=this.examen.preguntas[i].numero;
          i_contestada = i;
          si_hay_contestadas=true;

        }
      }
      if (!si_hay_contestadas) {this.examen.preguntas[0].active=true;}
    },
    Guardar_Avance(es_ultima){
      //solo enviar las respuestas de cada pregunta
      var preguntas=[];
      if (es_ultima) {console.log('Es ultima');this.Cargando();}
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        preguntas.push({
          numero:this.examen.preguntas[i].numero,
          respuesta:this.examen.preguntas[i].respuesta
        });
      }
      //post del avance
      this.$http.post('solicitudes/examen/avance',{
        tiempo_restante:this.tiempo_restante,
        avance:this.avance,
        idexamen:this.examen.idexamen,
        preguntas:preguntas
      })
      .then(respuesta=>{return respuesta.json()})
      .then(respuestaJson=>{
        if (respuestaJson.resp=='Excelente') {
          if (es_ultima) {
            this.$router.push({name:'Examenes'});
          }
        }else{
          swal("Hay un problema", "Revisa tu conexión a internet o recarga la página", "error");
        }
      })
      .catch(error=>{
        swal("Hay un problema", "Revisa tu conexión a internet o recarga la página", "error");
      });
    },
    Validar_Que_Esten_Contestadas_Todas_Las_Respuestas(){

      var that = this;
      var respuesta=false;
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        if (this.examen.preguntas[i].numero==this.pregunta_actual) {
          if (this.examen.preguntas[i].respuesta!=null) {
            respuesta=true;
          }
        }
      }
      if (respuesta && this.continuar_siguiente_pregunta_al_contestar) {
        setTimeout(function(){ 
          that.Cargando();
        }, 700);
        setTimeout(function(){ 
          that.Continuar_Siguiente_Pregunta();
        }, 900);
      }
    },
    Seleccionar_Respuesta(numero_pregunta,numero){
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        if (this.examen.preguntas[i].numero==numero_pregunta) {
          if (this.examen.preguntas[i].respuesta==numero) {
            this.examen.preguntas[i].respuesta=null;
          }else{
            this.examen.preguntas[i].respuesta=numero;
          }
        }
      }
      this.Validar_Que_Esten_Contestadas_Todas_Las_Respuestas();
    },
    Anterior_Pregunta(){
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        //if (this.examen.preguntas[i].numero==this.pregunta_actual) {
          this.examen.preguntas[i].active=false;
        //}
      }
      this.pregunta_actual--;
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        if (this.examen.preguntas[i].numero==this.pregunta_actual) {
          this.examen.preguntas[i].active=true;
        }
      }
    },
    Continuar_Siguiente_Pregunta(){  
      
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        //if (this.examen.preguntas[i].numero==this.pregunta_actual) {
          this.examen.preguntas[i].active=false;
        //}
      }
      this.cantidad_siguiente++;
      this.avance=(this.pregunta_actual*100)/this.total_preguntas;
      var continuar = true;
      if (this.pregunta_actual>=this.total_preguntas) {
        this.Guardar_Avance(true);
        continuar=false;
      }else if(this.cantidad_siguiente==20){
        this.cantidad_siguiente=1;
        this.Guardar_Avance();
      }
      if (continuar) {
        this.pregunta_actual++;
        for (var i = 0; i < this.examen.preguntas.length; i++) {
          if (this.examen.preguntas[i].numero==this.pregunta_actual) {
            this.examen.preguntas[i].active=true;
          }
        }
        this.Listo();
      }
    },
    Consultar_Preguntas(){
      this.Cargando();
      this.$http.get('solicitudes/mis/examenes/catell')
      .then(respuesta=>{return respuesta.json()})
      .then(respuestaJson=>{
        if (respuestaJson.resp=='Excelente') {
          this.examen=respuestaJson.examen;
          this.total_preguntas=respuestaJson.examen.preguntas.length;
          this.avance=respuestaJson.examen.avance;
          this.Buscar_Pregunta_Que_Se_Quedo();
          this.Listo();
        }else{
          this.Listo();
          swal("¡Ups!",respuestaJson.resp, "error");  
        }
      })
      .catch(error=>{
        this.Listo();
        swal("Favor de Intentar mas tarde", "Problemas para cargar las preguntas", "error");
      });
    },
    Cargando(){
      console.log('cargando');
      this.loading='';
      this.result='d-none';
    },
    Listo(){
      this.loading='d-none';
      this.result='';
    }
  },
  computed:{
    puedo_continuar(){
      var respuesta=false;
      for (var i = 0; i < this.examen.preguntas.length; i++) {
        if (this.examen.preguntas[i].numero==this.pregunta_actual) {
          if (this.examen.preguntas[i].respuesta!=null) {
            respuesta=true;
          }
        }
      }
      
      if (respuesta) {
        return 1;
      }else{
        return 0;
      }
    },
    mostrar_tiempo_restante(){
      return this.$store.getters.getMostrar_Tiempo_Restante;
    },
    avance_total(){
      return this.$store.getters.getAvance_Total;
    },
    tiempo_restante(){
      return this.$store.getters.getTiempo_Restante;
    },
    tiempo_restante_horas(){
      return this.$store.getters.getTiempo_Restante_Horas;
    }
  },
  mounted(){
    this.Consultar_Preguntas();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Examenes/Catell/Preguntas.vue